import { getFetchedDataPayload } from '../../../../../utils/fetched-data/get-fetched-data-payload';
import { loyaltyDomainStore } from '../../../store';
export const getBalanceTypes = () => {
    return Object.values(loyaltyDomainStore.data.balanceTypesById).reduce((acc, data) => {
        const balanceType = getFetchedDataPayload(data);
        if (balanceType)
            acc.push(balanceType);
        return acc;
    }, []);
};
